(function () {
  /* Reveal-on-scroll: add .is-visible the first time the section enters the
     viewport. CSS handles the actual fade-up (.pds-kuma__media and
     .pds-kuma__details). prefers-reduced-motion already skips the transition
     in CSS, so we still mark visible here — just the visual change is None. */
  function setupReveal(root) {
    if (root.classList.contains('is-visible')) return;
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  }

  function init(root) {
    setupReveal(root);

    var dataEl = root.querySelector('[data-pds-data]');
    var data = { variants: {}, defaultVariantId: null };
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    }

    var variantSelect = root.querySelector('[data-pds-variant-select]');
    var freqSelect = root.querySelector('[data-pds-frequency]');
    var freqWrap = root.querySelector('[data-pds-frequency-wrap]');
    var planInput = root.querySelector('[data-pds-selling-plan]');
    var priceEl = root.querySelector('[data-pds-price]');
    var addBtn = root.querySelector('[data-pds-add]');
    var buyBtn = root.querySelector('[data-pds-buy]');
    var subBtn = root.querySelector('[data-pds-purchase-type="subscription"]');
    var oneBtn = root.querySelector('[data-pds-purchase-type="onetime"]');
    var qtyInput = root.querySelector('[data-pds-qty-input]');
    var qtyValueEl = root.querySelector('[data-pds-qty-value]');
    var qtyButtons = root.querySelectorAll('[data-pds-qty-step]');

    var purchaseType =
      subBtn && subBtn.classList.contains('pds-kuma__purchase-option--active')
        ? 'subscription'
        : 'onetime';

    function currentVariantId() {
      if (variantSelect && variantSelect.value) return String(variantSelect.value);
      return data.defaultVariantId ? String(data.defaultVariantId) : null;
    }

    function currentVariantData() {
      var id = currentVariantId();
      if (!id) return null;
      return (data.variants && data.variants[id]) ? data.variants[id] : null;
    }

    function currentPlanId() {
      if (freqSelect && !freqSelect.disabled && freqSelect.value) return String(freqSelect.value);
      if (planInput && !planInput.disabled && planInput.value) return String(planInput.value);
      return null;
    }

    function variantHasSubscription(v) {
      return !!(v && v.allocations && Object.keys(v.allocations).length > 0);
    }

    function renderPrice() {
      if (!priceEl) return;
      var v = currentVariantData();
      if (!v) return;
      if (purchaseType === 'subscription') {
        var planId = currentPlanId();
        if (planId && v.allocations && v.allocations[planId]) {
          priceEl.textContent = v.allocations[planId];
          return;
        }
      }
      if (v.priceOnetime) priceEl.textContent = v.priceOnetime;
    }

    function setPurchaseType(type) {
      // Defensive: if the active variant has no allocations, force one-time.
      var v = currentVariantData();
      if (type === 'subscription' && !variantHasSubscription(v)) {
        type = 'onetime';
      }
      purchaseType = type;

      if (subBtn) {
        subBtn.classList.toggle('pds-kuma__purchase-option--active', type === 'subscription');
        subBtn.setAttribute('aria-pressed', type === 'subscription' ? 'true' : 'false');
      }
      if (oneBtn) {
        oneBtn.classList.toggle('pds-kuma__purchase-option--active', type === 'onetime');
        oneBtn.setAttribute('aria-pressed', type === 'onetime' ? 'true' : 'false');
      }

      // Disabled inputs/selects don't submit, so "selling_plan" simply
      // disappears from the form data when one-time is active.
      if (freqSelect) freqSelect.disabled = type !== 'subscription';
      if (planInput) planInput.disabled = type !== 'subscription';
      if (freqWrap) freqWrap.hidden = type !== 'subscription';

      renderPrice();
    }

    function onVariantChange() {
      var v = currentVariantData();
      var available = v ? !!v.available : false;

      if (addBtn) {
        addBtn.disabled = !available;
        var labelAvailable = addBtn.getAttribute('data-label-available');
        var labelSoldout = addBtn.getAttribute('data-label-soldout');
        if (labelAvailable && labelSoldout) {
          addBtn.textContent = available ? labelAvailable : labelSoldout;
        }
      }
      if (buyBtn) buyBtn.disabled = !available;

      // Re-apply current type — covers the fallback to one-time when the
      // newly-selected variant has no subscription allocations, and re-renders
      // the price to reflect both the new variant and the active plan.
      setPurchaseType(purchaseType);
    }

    function onBuyNow(event) {
      var form = buyBtn.closest('form');
      if (!form || buyBtn.disabled) return;
      event.preventDefault();

      // Disable while the add-to-cart request is in flight; if anything goes
      // wrong we re-enable and fall back to a plain form submit (which lands
      // on /cart, the existing behaviour).
      buyBtn.disabled = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart add failed: ' + response.status);
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyBtn.disabled = false;
          form.submit();
        });
    }

    function setQty(n) {
      if (!isFinite(n)) n = 1;
      n = Math.max(1, Math.floor(n));
      if (qtyValueEl) qtyValueEl.textContent = String(n);
      if (qtyInput) qtyInput.value = String(n);
    }

    function onQtyClick(event) {
      var step = parseInt(event.currentTarget.getAttribute('data-pds-qty-step'), 10);
      if (!step) return;
      var current = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      setQty((isFinite(current) ? current : 1) + step);
    }

    // Read more / read less: toggle the full description and swap the label.
    var descToggle = root.querySelector('[data-pds-desc-toggle]');
    var descFull = root.querySelector('[data-pds-desc-full]');
    var descWrap = root.querySelector('[data-pds-desc]');
    if (descToggle && descFull) {
      descToggle.addEventListener('click', function () {
        var expanded = descToggle.getAttribute('aria-expanded') === 'true';
        var next = !expanded;
        descFull.hidden = !next;
        descToggle.setAttribute('aria-expanded', next ? 'true' : 'false');
        // Drop the bottom fade once expanded; restore it when collapsed.
        if (descWrap) descWrap.classList.toggle('is-expanded', next);
        var more = descToggle.getAttribute('data-label-more') || 'Read more';
        var less = descToggle.getAttribute('data-label-less') || 'Read less';
        descToggle.textContent = next ? less : more;
      });
    }

    if (variantSelect) variantSelect.addEventListener('change', onVariantChange);
    if (freqSelect) freqSelect.addEventListener('change', renderPrice);
    if (subBtn) subBtn.addEventListener('click', function () { setPurchaseType('subscription'); });
    if (oneBtn) oneBtn.addEventListener('click', function () { setPurchaseType('onetime'); });
    if (buyBtn) buyBtn.addEventListener('click', onBuyNow);
    qtyButtons.forEach(function (btn) { btn.addEventListener('click', onQtyClick); });

    setPurchaseType(purchaseType);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.pds-kuma').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.pds-kuma');
    if (section) init(section);
  });
})();
